import React from 'react';
import { useTheme } from 'styled-components';

export const LeftArrowSvg = (props) => {
  const { onClick, width, height, color, double, circle, square } = props;

  const theme = useTheme();

  if (double) {
    return (
      <svg className="cursor-pointer" width={width ?? "9"} height={height ?? "9"} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.4375 6.52734L4.4375 3.52734L7.4375 0.527344" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 6.52734L1 3.52734L4 0.527344" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
  if (circle) {
    return (
      <svg width={width ?? "62"} height={height ?? "62"} viewBox="0 0 62 62" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.166687 30.9998C0.166687 13.9798 14.0109 0.166504 31 0.166504L31.8626 0.178357C48.4843 0.635674 61.8334 14.2683 61.8334 30.9998C61.8334 47.989 48.02 61.8332 31 61.8332C14.0109 61.8332 0.166687 47.989 0.166687 30.9998ZM37.105 43.3332C37.9992 42.4082 37.9992 40.959 37.0742 40.0648L27.9784 30.9998L37.0742 21.9348C37.9992 21.0407 37.9992 19.5607 37.105 18.6665C36.18 17.7415 34.7309 17.7415 33.8367 18.6665L23.0759 29.3657C22.6442 29.7973 22.3975 30.3832 22.3975 30.9998C22.3975 31.6165 22.6442 32.2023 23.0759 32.634L33.8367 43.3332C34.2684 43.7957 34.8542 44.0115 35.44 44.0115C36.0567 44.0115 36.6425 43.7957 37.105 43.3332Z" />
      </svg>
    )
  }
  if (square) {
    return (
      <svg width={width ?? "14"} height={height ?? "14"} viewBox="0 0 14 14" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.28016 0.333252H9.72683C12.0802 0.333252 13.6668 1.84725 13.6668 4.10659V9.88659C13.6668 12.1466 12.0802 13.6666 9.72683 13.6666H4.28016C1.92016 13.6666 0.333496 12.1466 0.333496 9.88659V4.10659C0.333496 1.84725 1.92016 0.333252 4.28016 0.333252ZM5.48683 7.49992H9.72016C10.0002 7.49992 10.2202 7.27325 10.2202 6.99992C10.2202 6.71992 10.0002 6.49992 9.72016 6.49992H5.48683L7.14016 4.85325C7.2335 4.75992 7.28683 4.62659 7.28683 4.49992C7.28683 4.37392 7.2335 4.24659 7.14016 4.14659C6.94683 3.95325 6.62683 3.95325 6.4335 4.14659L3.92016 6.64658C3.7335 6.83325 3.7335 7.16658 3.92016 7.35325L6.4335 9.85325C6.62683 10.0466 6.94683 10.0466 7.14016 9.85325C7.3335 9.65325 7.3335 9.33992 7.14016 9.13992L5.48683 7.49992Z" />
      </svg>

    )
  }
  return (
    <svg className="cursor-pointer" onClick={onClick} width={width ?? "9"} height={height ?? "9"} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.6788 1.36838L1.39258 4.6546L4.6788 7.94082" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.16185" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}


